// extracted by mini-css-extract-plugin
module.exports = {"root":"Panel_root__qBlnE"};